export const FILTER_DELAY = 300;

export function createFilterQueue({ send, delay = FILTER_DELAY, schedule = (callback, ms) => setTimeout(callback, ms), cancel = (id) => clearTimeout(id) }) {
  let timer = null;

  const clear = () => {
    if (timer === null) return;
    cancel(timer);
    timer = null;
  };

  return {
    change() {
      clear();
      timer = schedule(() => {
        timer = null;
        send();
      }, delay);
    },
    flush() {
      clear();
      send();
    },
    cancel: clear,
    pending: () => timer !== null,
  };
}
